import { useQuery } from '@tanstack/react-query';
import { Org, Organization } from '@/types';
import { getAllOrganizations } from '@/services/admin/get-all-organizations';
import { toOrganization } from '@/pages/admin/settings/helpers/to-organization';

export const ORGANIZATIONS_QUERY_KEY = ['admin', 'organizations'];

export const useGetOrganizations = () =>
  useQuery<Organization[]>({
    queryKey: ORGANIZATIONS_QUERY_KEY,
    queryFn: async () => {
      const response = await getAllOrganizations();
      if (response?.detail) throw new Error(response.detail);
      return ((response?.data as Org[]) ?? []).map(toOrganization);
    },
  });
